import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardFooter, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { TextBox } from 'devextreme-react/text-box';
import { Tooltip } from 'devextreme-react/tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DataGrid, Column, SearchPanel, LoadPanel, Paging, Scrolling, Pager } from 'devextreme-react/data-grid';
import Autorizar_Pases_Pendiente from './Autorizar_Pases_Pendiente';
import moment from 'moment';

export default function Detalle_Pases_Pendientes(props) {
    const [show, setShow] = useState(false);
    const [infoEmpleado, setInfoEmpleado] = useState(null);
    const [pAutorizada,setPAutorizada] = useState(null);
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [tooltipOpenClose, setTooltipOpenClose] = useState(false);
    const [showAutorizar, setShowAutorizar] = useState(false);
    const [autorizar, setAutorizar] = useState(null);
    const [data, setData] = useState(null);
    const [refresh, setRefresh] = useState(null);
    const [dataParams, setDataParams] = useState(null);
    const [usuario, setUsuario] = useState(null);
    const [noEmpleado, setNoEmpleado] = useState(null);

    const allowedPageSizes = [5, 10, 'all'];

    const toolTip = () => setTooltipOpen(!tooltipOpen);
    const toolTipClose = () => setTooltipOpenClose(!tooltipOpenClose);

    const abrirAutorizar = () => {
        //autorizar.Documento = `34${autorizar.Documento}`;
        setShowAutorizar(true);
    }

    const cerrarAutorizar = (e) => {
        setShowAutorizar(e);
    }

    useEffect(() => {
        setShow(props.abrirModal);
        setInfoEmpleado(props.detalle);
        setData(props.detalle?.PasesDetalleDto);
        setUsuario(sessionStorage.getItem("user"));
        setNoEmpleado(sessionStorage.getItem("noEmpleado"));
        setAutorizar(props.detalle);
        setRefresh(props.refresh);
        return () => {
            setShow(false);
            setInfoEmpleado(null);
        }
    });

    const cerrarModal = () => {
        props.cerrarModal(false)
        setShow(false);
    }

    useEffect(() => {
        cerrarModal();
    }, [showAutorizar])

    return (
        <div>
            <Modal isOpen={show} toggle={cerrarModal} backdrop="static" size="lg">
                <ModalHeader>
                    Detalle Tipo Pase {infoEmpleado?.TipoPase}
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col sm={{ size: 6, order: 1 }}>
                                            <label className="col-form-label fs-6 fw-bold">Fecha</label>
                                            <TextBox
                                                readOnly={true}
                                                defaultValue={infoEmpleado ? moment(infoEmpleado.Fecha).format('DD/MM/YYYY') : "Sin fecha"}
                                            />
                                        </Col>
                                        <Col sm={{ size: 6, order: 1 }}>
                                            <label className="col-form-label fs-6 fw-bold">Persona Autorizada</label>
                                            <TextBox
                                                readOnly={true}
                                                defaultValue={infoEmpleado ? infoEmpleado.NombreReponsable : "Sin Persona Autorizada"}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={{ size: 6, order: 1 }}>
                                            <label className="col-form-label fs-6 fw-bold">Documento</label>
                                            <TextBox
                                                readOnly={true}
                                                defaultValue={infoEmpleado ? infoEmpleado.Documento : "Sin documento"}
                                            />
                                        </Col>
                                        <Col sm={{ size: 6, order: 1 }}>
                                            <label className="col-form-label fs-6 fw-bold">No. Pase</label>
                                            <TextBox
                                                readOnly={true}
                                                defaultValue={infoEmpleado ? infoEmpleado.NoDocumento : "Sin fecha de vencimiento"}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <DataGrid
                                            dataSource={data}
                                            showBorders={true}
                                            columnHidingEnabled={true}
                                            columnAutoWidth={true}
                                            wordWrapEnabled={true}
                                            columnMinWidth={50}
                                            className="mt-2"
                                        >
                                            <SearchPanel
                                                visible={true}
                                                width={240}
                                                placeholder="Buscar..." />
                                            <LoadPanel enabled={true} />
                                            <Scrolling mode="virtual" rowRenderingMode="virtual" />
                                            <Paging defaultPageSize={10} />
                                            <Pager
                                                visible={true}
                                                allowedPageSizes={allowedPageSizes} />
                                            <Column dataField="CodigoProducto" caption="Codigo"/>
                                            <Column dataField="DescripcionProducto" caption="Descripción"/>
                                            <Column dataField="IdProducto" caption="ID"/>
                                            <Column dataField="Cantidad" />
                                            <Column dataField="Referencia" />
                                        </DataGrid>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <button id="btnAutorizar"
                        className="btn btn-outline-success"
                        onClick={abrirAutorizar}
                        onMouseEnter={toolTip}
                        onMouseLeave={toolTip}>
                        <FontAwesomeIcon icon="check" size="2x" />
                    </button>
                    <Tooltip
                        target="#btnAutorizar"
                        position="top"
                        visible={tooltipOpen}
                        closeOnOutsideClick={false}
                    >
                        <div>Autorizar</div>
                    </Tooltip>
                    <button id="btnCancelar"
                        className="btn btn-outline-danger"
                        onClick={cerrarModal}
                        onMouseEnter={toolTipClose}
                        onMouseLeave={toolTipClose}>
                        <FontAwesomeIcon icon="times" size="2x" />
                    </button>
                    <Tooltip
                        target="#btnCancelar"
                        position="top"
                        visible={tooltipOpenClose}
                        closeOnOutsideClick={false}
                    >
                        <div>Cerrar</div>
                    </Tooltip>
                </ModalFooter>
            </Modal>
            <Autorizar_Pases_Pendiente abrirModal={showAutorizar} cerrarModal={cerrarAutorizar} autorizar={autorizar} refresh={refresh} dataUpdate={props.dataUpdate} />
        </div>
    )
}